import cx from "clsx";
import { HighlightGalleryCollector } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";

import GalleryAvatarViewer$WithCustomFrame from "../../../../../PageUpdateGalleryInfo/components/GalleryAvatarViewer$WithCustomFrame";
import { isFrameKey } from "../../../../../PageUpdateGalleryInfo/components/GalleryAvatarViewer$WithCustomFrame/config";
import GalleryAvatarViewer$WithoutCustomFrame from "../../../../../PageUpdateGalleryInfo/components/GalleryAvatarViewer$WithoutCustomFrame";

import styles from "./index.module.scss";

import { formatInteger$Compact } from "@/modules/common-utils/format";
import { EM_DASH } from "@/modules/common-utils/unicode";
import SocialLinksViewer from "@/modules/kreate-components/components/SocialLinksViewer";
import { getLinkToPageGalleryCollector } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  galleryCollector: HighlightGalleryCollector | null | undefined;
};

export default function CardGallery({
  className,
  style,
  galleryCollector,
}: Props) {
  const firstAddress = galleryCollector?.addresses[0].address;
  const socialLinks =
    galleryCollector?.populated?.galleryInfo?.socialLinks || [];
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Col alignItems="center" gap="12px">
        <Link
          href={
            firstAddress
              ? getLinkToPageGalleryCollector(firstAddress)
              : "#disabled"
          }
        >
          {galleryCollector?.populated?.galleryInfo?.customFrame &&
          isFrameKey(galleryCollector.populated.galleryInfo.customFrame) ? (
            <GalleryAvatarViewer$WithCustomFrame
              avatar={galleryCollector.populated.galleryInfo.avatar}
              size="160px"
              frame={galleryCollector.populated.galleryInfo.customFrame}
            />
          ) : (
            <GalleryAvatarViewer$WithoutCustomFrame
              avatar={galleryCollector?.populated?.galleryInfo?.avatar}
              size="88px"
              border
            />
          )}
        </Link>
        <Link
          href={
            firstAddress ? getLinkToPageGalleryCollector(firstAddress) : "#"
          }
          className={styles.title}
        >
          {galleryCollector?.populated?.galleryInfo?.title || EM_DASH}
        </Link>
        {galleryCollector?.populated?.galleryInfo?.description ? (
          <div className={styles.description}>
            {galleryCollector?.populated?.galleryInfo?.description}
          </div>
        ) : undefined}
        <div className={styles.textGalleryStats}>
          <span
            title={
              galleryCollector?.totalNumArtworks != null
                ? `${formatInteger$Compact(
                    galleryCollector?.totalNumArtworks
                  )} Artworks`
                : undefined
            }
          >{`${
            galleryCollector?.totalNumArtworks != null
              ? formatInteger$Compact(galleryCollector?.totalNumArtworks)
              : EM_DASH
          } Artworks`}</span>
          <span className={styles.colorFgDivider}>{` • `}</span>
          <span>{`${
            galleryCollector?.totalNumAlbums ?? EM_DASH
          } Exhibits`}</span>
        </div>
        <SocialLinksViewer
          style={{ marginTop: "8px" }}
          justifyContent="center"
          socialLinks={socialLinks}
        />
      </Flex.Col>
    </div>
  );
}
